module.exports = __webpack_public_path__ + "static/media/logicarts.2737b005.png";